module.exports = __webpack_public_path__ + "img/title6.b01e1add.png";